<template>
  <div class="agreement-page">
    <!-- 背景装饰 -->
    <div class="page-bg">
      <div class="bg-shape shape-1"></div>
      <div class="bg-shape shape-2"></div>
      <div class="bg-shape shape-3"></div>
    </div>

    <!-- 主要内容 -->
    <div class="agreement-container">
      <!-- 头部 -->
      <div class="agreement-header">
        <div class="header-content">
          <div class="title-section">
            <i class="title-icon">📜</i>
            <h1>用户服务协议</h1>
            <p>User Service Agreement</p>
          </div>
          <div class="header-decoration">
            <div class="decoration-line"></div>
            <div class="decoration-dot"></div>
            <div class="decoration-line"></div>
          </div>
        </div>
        <div class="header-meta">
          <div class="meta-item">
            <i class="meta-icon">📅</i>
            <span>最后更新：2026年3月</span>
          </div>
          <div class="meta-item">
            <i class="meta-icon">⏱️</i>
            <span>阅读时间：约15分钟</span>
          </div>
        </div>
      </div>

      <!-- 目录导航 -->
      <div class="toc-sidebar">
        <div class="toc-card">
          <div class="toc-header">
            <i class="toc-icon">📑</i>
            <h3>目录导航</h3>
          </div>
          <nav class="toc-nav">
            <a href="#p1" class="toc-link">一. 定义</a>
            <a href="#p2" class="toc-link">二. 承诺与保证</a>
            <a href="#p3" class="toc-link">三. 服务条款确认</a>
            <a href="#p4" class="toc-link">四. 服务内容</a>
            <a href="#p5" class="toc-link">五. 注册用户账号</a>
            <a href="#p6" class="toc-link">六. 隐私保护</a>
            <a href="#p7" class="toc-link">七. 服务修改终止</a>
            <a href="#p8" class="toc-link">八. 用户权责</a>
            <a href="#p9" class="toc-link">九. 知识产权</a>
            <a href="#p10" class="toc-link">十. 管辖法律</a>
            <a href="#p11" class="toc-link">十一. 附则</a>
          </nav>
        </div>
      </div>

      <!-- 协议内容 -->
      <div class="agreement-content">
        <div class="content-card">
          <!-- 引言部分 -->
          <div class="article-intro">
            <div class="intro-icon">👋</div>
            <p>欢迎使用我们的服务！本协议是您与我们之间就相关服务事宜所订立的协议，具有合同效力。请您仔细阅读并理解本协议的所有内容。</p>
          </div>

          <!-- 协议正文 -->
          <div class="article-content">
            <!-- 一. 定义 -->
            <section id="p1" class="content-section">
              <div class="section-header">
                <span class="section-number">01</span>
                <h2>定义</h2>
              </div>
              <div class="section-content">
                <div class="definition-list">
                  <div class="definition-item">
                    <span class="def-term">【本协议】</span>
                    <span class="def-desc">系您与我们之间关于使用相关服务所订立的协议。</span>
                  </div>
                  <div class="definition-item">
                    <span class="def-term">【用户】</span>
                    <span class="def-desc">系相关服务的使用人，在本协议中简称为"您"。</span>
                  </div>
                  <div class="definition-item">
                    <span class="def-term">【服务】</span>
                    <span class="def-desc">指您访问平台时我们向您提供的产品和服务。</span>
                  </div>
                </div>
              </div>
            </section>

            <!-- 二. 承诺与保证 -->
            <section id="p2" class="content-section">
              <div class="section-header">
                <span class="section-number">02</span>
                <h2>承诺与保证</h2>
              </div>
              <div class="section-content">
                <div class="clause-group">
                  <h4>承诺条款</h4>
                  <p>您理解并同意：</p>
                  <ul class="clause-list">
                    <li>我们有权在您违反本协议时，适用平台规则予以处理或终止向您提供服务。</li>
                    <li>对于您发布的涉嫌违法或违反本协议的信息，我们有权不通知您即予以删除。</li>
                    <li class="highlight-text">对于您提供的资料及数据信息，您授予我们独家的、全球通用的、永久的、免费的许可使用权利。</li>
                  </ul>
                </div>
              </div>
            </section>

            <!-- 三. 服务条款确认 -->
            <section id="p3" class="content-section">
              <div class="section-header">
                <span class="section-number">03</span>
                <h2>服务条款确认</h2>
              </div>
              <div class="section-content">
                <div class="important-notice">
                  <div class="notice-header">
                    <i class="notice-icon">⚠️</i>
                    <span>重要提示</span>
                  </div>
                  <p class="highlight-text">各项服务的所有权和运作权归我们所有。您确认：本协议条款是处理双方权利义务的依据之一，始终有效。</p>
                  <p class="highlight-text">您知悉并确认，如您不同意更新后的内容，应立即停止使用相关服务；如您继续使用，即视为知悉变动内容并同意接受。</p>
                </div>
              </div>
            </section>

            <!-- 四. 服务内容 -->
            <section id="p4" class="content-section">
              <div class="section-header">
                <span class="section-number">04</span>
                <h2>服务内容</h2>
              </div>
              <div class="section-content">
                <div class="service-cards">
                 
                  <div class="service-card">
                    <i class="service-icon">💎</i>
                    <h5>注册付费下载</h5>
                    <p>部分高级服务需要付费使用，具体以平台说明为准。</p>
                  </div>
                </div>
              </div>
            </section>

            <!-- 五. 注册用户账号 -->
            <section id="p5" class="content-section">
              <div class="section-header">
                <span class="section-number">05</span>
                <h2>注册用户账号</h2>
              </div>
              <div class="section-content">
                <div class="requirement-list">
                  <h4>注册条件</h4>
                  <div class="requirement-item">
                    <i class="req-icon">✅</i>
                    <span>年满十八周岁，具有民事权利能力和行为能力的自然人</span>
                  </div>
                  <div class="requirement-item">
                    <i class="req-icon">✅</i>
                    <span>未满十八周岁但监护人书面同意的自然人</span>
                  </div>
                  <div class="requirement-item">
                    <i class="req-icon">✅</i>
                    <span>依法成立并合法存在的企业法人、事业单位等组织</span>
                  </div>
                </div>
                <p class="highlight-text">您应对您的账户和密码的安全，以及对通过您的账户和密码实施的行为负责。</p>
              </div>
            </section>

            <!-- 六. 隐私保护 -->
            <section id="p6" class="content-section">
              <div class="section-header">
                <span class="section-number">06</span>
                <h2>隐私保护</h2>
              </div>
              <div class="section-content">
                <div class="privacy-card">
                  <i class="privacy-icon">🔒</i>
                  <p>我们谨守保护您个人信息及隐私的基本准则。我们对相关信息采取专业加密存储与传输方式，利用合理措施保障您个人信息的安全。</p>
                </div>
              </div>
            </section>

            <!-- 七. 服务修改终止 -->
            <section id="p7" class="content-section">
              <div class="section-header">
                <span class="section-number">07</span>
                <h2>服务修改与终止</h2>
              </div>
              <div class="section-content">
                <p>鉴于网络服务的特殊性，您同意我们有权不经事先通知，随时变更、中断或终止部分或全部的网络服务。我们不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。</p>
              </div>
            </section>

            <!-- 八. 用户权责 -->
            <section id="p8" class="content-section">
              <div class="section-header">
                <span class="section-number">08</span>
                <h2>用户权利与责任</h2>
              </div>
              <div class="section-content">
                <div class="responsibility-grid">
                  <div class="responsibility-item">
                    <i class="resp-icon">👍</i>
                    <span>提供真实个人资料</span>
                  </div>
                  <div class="responsibility-item">
                    <i class="resp-icon">🚫</i>
                    <span>不得进行违法活动</span>
                  </div>
                  <div class="responsibility-item">
                    <i class="resp-icon">📝</i>
                    <span>及时更新个人信息</span>
                  </div>
                  <div class="responsibility-item">
                    <i class="resp-icon">⚖️</i>
                    <span>承担法律责任</span>
                  </div>
                </div>
              </div>
            </section>

            <!-- 九. 知识产权 -->
            <section id="p9" class="content-section">
              <div class="section-header">
                <span class="section-number">09</span>
                <h2>知识产权</h2>
              </div>
              <div class="section-content">
                <div class="ip-notice">
                  <i class="ip-icon">💡</i>
                  <p>平台及平台所使用的任何相关软件、程序、内容，包括但不限于作品、图片、商业标识、档案、资料等，均由我们或其它权利人依法享有相应的知识产权。</p>
                </div>
              </div>
            </section>

            <!-- 十. 管辖与法律适用 -->
            <section id="p10" class="content-section">
              <div class="section-header">
                <span class="section-number">10</span>
                <h2>管辖与法律适用</h2>
              </div>
              <div class="section-content">
                <p class="highlight-text">若您和我们之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交协议签订地有管辖权的人民法院管辖。</p>
              </div>
            </section>

            <!-- 十一. 附则 -->
            <section id="p11" class="content-section">
              <div class="section-header">
                <span class="section-number">11</span>
                <h2>附则</h2>
              </div>
              <div class="section-content">
                <div class="final-clauses">
                  <p>本协议生效前的注册用户只需要使用原用户名及密码登录平台重新接受并确认本协议，即可继续使用服务。</p>
                  <p>协议有效期：从您同意本协议或使用服务之日起至您注销服务之日止。</p>
                </div>
              </div>
            </section>

          
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "agreement",
  mounted() {
    document.title = "京游科技（北京）有限公司";
    
    // 添加滚动监听高亮目录
    this.setupTocHighlight();
  },
  methods: {
    setupTocHighlight() {
      const sections = document.querySelectorAll('.content-section');
      const links = document.querySelectorAll('.toc-link');
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute('id');
            links.forEach(link => {
              link.classList.remove('active');
              if (link.getAttribute('href') === `#${id}`) {
                link.classList.add('active');
              }
            });
          }
        });
      }, { threshold: 0.5 });
      
      sections.forEach(section => observer.observe(section));
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.agreement-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
  overflow-x: hidden;

  // 背景装饰
  .page-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    
    .bg-shape {
      position: absolute;
      border-radius: 50%;
      background: rgba(24, 144, 255, 0.05);
      animation: float 8s ease-in-out infinite;
      
      &.shape-1 {
        width: 200px;
        height: 200px;
        top: 10%;
        left: 5%;
        animation-delay: 0s;
      }
      
      &.shape-2 {
        width: 150px;
        height: 150px;
        top: 60%;
        right: 10%;
        animation-delay: 2s;
        animation-direction: reverse;
      }
      
      &.shape-3 {
        width: 100px;
        height: 100px;
        bottom: 20%;
        left: 15%;
        animation-delay: 4s;
      }
    }
  }

  .agreement-container {
    position: relative;
    z-index: 2;
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;

    // 头部
    .agreement-header {
      text-align: center;
      margin-bottom: 50px;
      
      .header-content {
        .title-section {
          margin-bottom: 30px;
          
          .title-icon {
            font-size: 64px;
            display: block;
            margin-bottom: 20px;
            background: linear-gradient(135deg, #1890ff, #52c41a);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
          }
          
          h1 {
            font-size: 42px;
            font-weight: 700;
            color: #1a1a1a;
            margin: 0 0 10px 0;
            background: linear-gradient(135deg, #1890ff, #52c41a);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          
          p {
            font-size: 18px;
            color: #666;
            margin: 0;
            font-weight: 500;
          }
        }
        
        .header-decoration {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 15px;
          margin-bottom: 30px;
          
          .decoration-line {
            width: 60px;
            height: 2px;
            background: linear-gradient(90deg, #1890ff, #52c41a);
            border-radius: 1px;
          }
          
          .decoration-dot {
            width: 8px;
            height: 8px;
            background: #1890ff;
            border-radius: 50%;
            animation: pulse 2s infinite;
          }
        }
      }
      
      .header-meta {
        display: flex;
        justify-content: center;
        gap: 30px;
        
        .meta-item {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 16px;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 20px;
          font-size: 14px;
          color: #666;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          
          .meta-icon {
            font-size: 16px;
          }
        }
      }
    }

    // 目录侧边栏
    .toc-sidebar {
      position: sticky;
      top: 100px;
      float: left;
      width: 280px;
      margin-right: 40px;
      
      .toc-card {
        background: #fff;
        border-radius: 16px;
        padding: 24px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(0, 0, 0, 0.05);
        
        .toc-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
          padding-bottom: 16px;
          border-bottom: 2px solid #f0f0f0;
          
          .toc-icon {
            font-size: 20px;
            background: linear-gradient(135deg, #1890ff, #52c41a);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          
          h3 {
            font-size: 18px;
            font-weight: 600;
            color: #1a1a1a;
            margin: 0;
          }
        }
        
        .toc-nav {
          display: flex;
          flex-direction: column;
          gap: 8px;
          
          .toc-link {
            padding: 12px 16px;
            color: #666;
            text-decoration: none;
            border-radius: 8px;
            transition: all 0.3s ease;
            font-size: 14px;
            font-weight: 500;
            
            &:hover {
              color: #1890ff;
              background: rgba(24, 144, 255, 0.05);
              transform: translateX(4px);
            }
            
            &.active {
              color: #1890ff;
              background: rgba(24, 144, 255, 0.1);
              font-weight: 600;
              border-left: 3px solid #1890ff;
            }
          }
        }
      }
    }

    // 协议内容
    .agreement-content {
      margin-left: 320px;
      
      .content-card {
        background: #fff;
        border-radius: 20px;
        padding: 50px;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(0, 0, 0, 0.05);
        
        // 引言
        .article-intro {
          display: flex;
          align-items: flex-start;
          gap: 20px;
          padding: 30px;
          background: linear-gradient(135deg, rgba(24, 144, 255, 0.05), rgba(82, 196, 26, 0.05));
          border-radius: 16px;
          margin-bottom: 40px;
          border-left: 4px solid #1890ff;
          
          .intro-icon {
            font-size: 32px;
            margin-top: 4px;
          }
          
          p {
            font-size: 16px;
            line-height: 1.7;
            color: #595959;
            margin: 0;
            font-weight: 500;
          }
        }

        // 内容区块
        .content-section {
          margin-bottom: 60px;
          scroll-margin-top: 100px;
          
          .section-header {
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
            padding-bottom: 20px;
            border-bottom: 2px solid #f0f0f0;
            
            .section-number {
              font-size: 48px;
              font-weight: 700;
              color: #e6f7ff;
              background: linear-gradient(135deg, #1890ff, #52c41a);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              line-height: 1;
            }
            
            h2 {
              font-size: 28px;
              font-weight: 700;
              color: #1a1a1a;
              margin: 0;
            }
          }
          
          .section-content {
            // 定义列表
            .definition-list {
              display: flex;
              flex-direction: column;
              gap: 16px;
              
              .definition-item {
                display: flex;
                align-items: flex-start;
                gap: 12px;
                padding: 16px;
                background: #f8f9fa;
                border-radius: 8px;
                border-left: 4px solid #1890ff;
                
                .def-term {
                  font-weight: 600;
                  color: #1890ff;
                  min-width: 100px;
                }
                
                .def-desc {
                  color: #595959;
                  line-height: 1.6;
                }
              }
            }
            
            // 条款列表
            .clause-list {
              list-style: none;
              padding: 0;
              
              li {
                padding: 12px 0 12px 24px;
                position: relative;
                line-height: 1.6;
                color: #595959;
                
                &::before {
                  content: '•';
                  position: absolute;
                  left: 8px;
                  color: #1890ff;
                  font-weight: bold;
                }
                
                &.highlight-text {
                  background: rgba(255, 152, 0, 0.05);
                  padding: 16px;
                  border-radius: 8px;
                  border-left: 4px solid #ff9800;
                  font-weight: 600;
                  color: #e65100;
                }
              }
            }
            
            // 重要通知
            .important-notice {
              padding: 24px;
              background: rgba(255, 152, 0, 0.05);
              border-radius: 12px;
              border: 1px solid rgba(255, 152, 0, 0.2);
              
              .notice-header {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 16px;
                
                .notice-icon {
                  font-size: 20px;
                }
                
                span {
                  font-weight: 600;
                  color: #e65100;
                }
              }
            }
            
            // 服务卡片
            .service-cards {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
              gap: 20px;
              
              .service-card {
                text-align: center;
                padding: 30px 20px;
                background: #f8f9fa;
                border-radius: 12px;
                transition: all 0.3s ease;
                border: 2px solid transparent;
                
                &:hover {
                  transform: translateY(-4px);
                  border-color: #1890ff;
                  box-shadow: 0 8px 25px rgba(24, 144, 255, 0.15);
                }
                
                .service-icon {
                  font-size: 32px;
                  margin-bottom: 16px;
                  display: block;
                }
                
                h5 {
                  font-size: 18px;
                  font-weight: 600;
                  color: #1a1a1a;
                  margin: 0 0 12px 0;
                }
                
                p {
                  font-size: 14px;
                  color: #666;
                  line-height: 1.5;
                  margin: 0;
                }
              }
            }
            
            // 要求列表
            .requirement-list {
              .requirement-item {
                display: flex;
                align-items: center;
                gap: 12px;
                padding: 12px 0;
                border-bottom: 1px solid #f0f0f0;
                
                .req-icon {
                  font-size: 16px;
                  color: #52c41a;
                }
                
                span {
                  color: #595959;
                }
              }
            }
            
            // 隐私卡片
            .privacy-card {
              display: flex;
              align-items: flex-start;
              gap: 20px;
              padding: 24px;
              background: rgba(24, 144, 255, 0.05);
              border-radius: 12px;
              border: 1px solid rgba(24, 144, 255, 0.2);
              
              .privacy-icon {
                font-size: 32px;
                margin-top: 4px;
              }
              
              p {
                margin: 0;
                line-height: 1.6;
                color: #595959;
              }
            }
            
            // 责任网格
            .responsibility-grid {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
              gap: 16px;
              
              .responsibility-item {
                display: flex;
                align-items: center;
                gap: 12px;
                padding: 16px;
                background: #f8f9fa;
                border-radius: 8px;
                transition: all 0.3s ease;
                
                &:hover {
                  background: rgba(24, 144, 255, 0.05);
                  transform: translateY(-2px);
                }
                
                .resp-icon {
                  font-size: 20px;
                }
                
                span {
                  font-weight: 500;
                  color: #595959;
                }
              }
            }
            
            // IP通知
            .ip-notice {
              display: flex;
              align-items: flex-start;
              gap: 16px;
              padding: 20px;
              background: rgba(82, 196, 26, 0.05);
              border-radius: 12px;
              border: 1px solid rgba(82, 196, 26, 0.2);
              
              .ip-icon {
                font-size: 24px;
                margin-top: 2px;
              }
              
              p {
                margin: 0;
                line-height: 1.6;
                color: #595959;
              }
            }
            
            // 最终条款
            .final-clauses {
              p {
                padding: 12px 0;
                line-height: 1.6;
                color: #595959;
                border-bottom: 1px solid #f0f0f0;
                
                &:last-child {
                  border-bottom: none;
                }
              }
            }
          }
        }

        // 高亮文本
        .highlight-text {
          background: rgba(255, 152, 0, 0.05);
          padding: 16px;
          border-radius: 8px;
          border-left: 4px solid #ff9800;
          font-weight: 600;
          color: #e65100;
          line-height: 1.6;
        }

        // 协议确认
        .agreement-confirm {
          margin-top: 60px;
          padding-top: 40px;
          border-top: 2px solid #f0f0f0;
          
          .confirm-card {
            text-align: center;
            padding: 40px;
            background: linear-gradient(135deg, rgba(24, 144, 255, 0.05), rgba(82, 196, 26, 0.05));
            border-radius: 16px;
            border: 2px dashed #1890ff;
            
            .confirm-icon {
              font-size: 48px;
              display: block;
              margin-bottom: 20px;
              background: linear-gradient(135deg, #1890ff, #52c41a);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
            
            h4 {
              font-size: 24px;
              font-weight: 600;
              color: #1a1a1a;
              margin: 0 0 16px 0;
            }
            
            p {
              font-size: 16px;
              color: #666;
              line-height: 1.6;
              margin: 0 0 30px 0;
            }
            
            .confirm-actions {
              .confirm-btn {
                display: inline-flex;
                align-items: center;
                gap: 8px;
                padding: 16px 32px;
                background: linear-gradient(135deg, #52c41a, #1890ff);
                color: #fff;
                border: none;
                border-radius: 12px;
                font-size: 16px;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;
                
                &:hover {
                  transform: translateY(-2px);
                  box-shadow: 0 8px 25px rgba(82, 196, 26, 0.4);
                }
                
                i {
                  font-size: 18px;
                  font-weight: bold;
                }
              }
            }
          }
        }
      }
    }
  }
}

// 动画定义
@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-10px) rotate(180deg);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.7;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
    box-shadow: 0 0 10px #1890ff;
  }
}

// 入场动画
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.content-section {
  animation: fadeInUp 0.6s ease forwards;
}

// 响应式设计
@media (max-width: 1024px) {
  .toc-sidebar {
    display: none;
  }
  
  .agreement-content {
    margin-left: 0 !important;
  }
}

@media (max-width: 768px) {
  .agreement-container {
    padding: 20px 16px !important;
  }
  
  .content-card {
    padding: 30px 20px !important;
  }
  
  .header-meta {
    flex-direction: column;
    gap: 12px !important;
  }
  
  .service-cards {
    grid-template-columns: 1fr !important;
  }
  
  .responsibility-grid {
    grid-template-columns: 1fr !important;
  }
}
</style>